module.exports = __webpack_public_path__ + "img/etno-bank.0baef145.jpg";